/**
 * Generate full user name by name keys
 */
export const formatUserName = (data: object, keys = ['firstName', 'lastName']) => {
  const name = [];

  keys.forEach((key) => {
    if (data && data[key]) {
      name.push(data[key]);
    }
  });

  return name.length ? name.join(' ') : '';
};
